import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
/**
 * This class displays the Recruiter Bonus Emojies.
 */
@Component({
    selector: 'nova-recruiter-bonus',
    standalone: true,
    imports: [CurrencyPipe],
    templateUrl: './recruiter-bonus.component.html',
    styleUrls: ['./recruiter-bonus.component.scss']
})
export class RecruiterBonusComponent {
    @Input() bonus = 0;
}
